import request from './request'

/** 注册 {username, password, nickname} */
export function register(payload) {
  return request.post('/auth/register', payload)
}

/** 登录 {username, password, captcha} → {token, id, username, nickname, role}
 *  username/password 走 body（避免 URL 泄露）；captcha 走 query（供 JFinal validateCaptcha） */
export function login(payload) {
  const body = { username: payload.username, password: payload.password }
  return request.post('/auth/login', body, { params: { captcha: payload.captcha } })
}

/** 登出 */
export function logout() {
  return request.post('/auth/logout')
}

/** 当前登录用户 */
export function fetchMe() {
  return request.get('/auth/me')
}
